module.exports = __webpack_public_path__ + "img/golden_oak_696l_detail_rsh.f4b97711.jpg";